import { useDispatch, useSelector } from "react-redux";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { Form, Steps } from "antd";
import { useEffect, useRef, useState } from "react";
import toast from "react-hot-toast";
import { save } from "../../../features/save/saveSlice";
import Step3 from "./statement_steps/Step3";
import BreadCrumb from "../../../layout/BreadCrumb";
import { capitalize } from "../../../utils";
import flash from "../../../assets/svg/Flash.svg";
import AddGroupModal from "../groups_/modal/AddGroupModal";
import { fetchPaymentGroups } from "../../../features/fetch/fetchSlice";
import Step1 from "./statement_steps/Step1";
import { setActiveObj, setcurrent } from "../../../features/obj/objSlice";
import Step2 from "./statement_steps/Step2";

export default function Groups() {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { authData } = useSelector((state) => state.auth);
  const { activeObj,current } = useSelector((state) => state.obj);
  const { paymentGroups } = useSelector((state) => state.fetch);
  const [open, setopen] = useState(false);

  function handleAddGroup() {
    setopen(true);
  }

  function handleCancel() {
    setopen(false);
  }
  const [prodd1, setProdd1] = useState("");

  const formRef = useRef(null);
 

  const onFinish = async () => {
    const res = await dispatch(
      save({
        // ...activeObj,
        url: "api/v1/public/create-organisation",
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.messages?.message);
      // await dispatch(cleanactiveObj());
      // await form.resetFields();
      // await navigate('/registration-success')
    } else {
      toast.error(res?.payload?.messages?.message);
    }
  };

  function handleNext() {
      dispatch(setcurrent(current + 1));
  }

  function handleBack() {
   dispatch(setcurrent(current - 1));
  }

  const steps = [
    {
      key: 0,
      title: "Groups",
      content: <Step1 handleNext={handleNext} form={form} />,
    },

    {
      key: 1,
      title: "Group Members",
      content: (
        <Step2
          handleNext={handleNext}
          handleBack={handleBack}
          form={form} 
        />
      ),
    },

    {
      key: 2,
      title: "Payments Verification",
      content: <Step3 handleBack={handleBack} form={form} />,
    },
  ];

  const items = steps.map((item) => ({
    key: item.key,
    title: item.title,
    icon: item.icon,
  }));

  async function handleFetch() {
    await dispatch(
      fetchPaymentGroups({
        url: "api/v1/payments/fetch-payment-groups",
      })
    );
  }
 
  useEffect(() => {
    handleFetch();
  }, []);

  useEffect(() => {
    form.setFieldsValue({
      ...activeObj,
    });
  }, [activeObj, form]);

  const breadList = [
    {
      title: (
        <div className="flex items-center gap-[.25rem]">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
          >
            <g clipPath="url(#clip0_627_13942)">
              <path
                d="M13.7899 6.89067L7.75241 0.856289L7.34772 0.451602C7.25551 0.360003 7.13082 0.308594 7.00085 0.308594C6.87087 0.308594 6.74618 0.360003 6.65397 0.451602L0.211783 6.89067C0.117301 6.98478 0.0426296 7.09687 -0.00782254 7.22031C-0.0582747 7.34376 -0.0834854 7.47607 -0.0819665 7.60942C-0.0757165 8.15942 0.382096 8.59848 0.932096 8.59848H1.59616V13.6875H12.4055V8.59848H13.0837C13.3508 8.59848 13.6024 8.49379 13.7915 8.30473C13.8846 8.21193 13.9583 8.10159 14.0085 7.98009C14.0586 7.8586 14.0842 7.72836 14.0837 7.59692C14.0837 7.33129 13.979 7.07973 13.7899 6.89067ZM7.87585 12.5625H6.12585V9.37504H7.87585V12.5625ZM11.2805 7.47348V12.5625H8.87585V9.00004C8.87585 8.65473 8.59616 8.37504 8.25085 8.37504H5.75085C5.40553 8.37504 5.12585 8.65473 5.12585 9.00004V12.5625H2.72116V7.47348H1.22116L7.00241 1.69691L7.36335 2.05785L12.7821 7.47348H11.2805Z"
                fill="black"
                fillOpacity="0.45"
              />
            </g>
            <defs>
              <clipPath id="clip0_627_13942">
                <rect width="14" height="14" fill="white" />
              </clipPath>
            </defs>
          </svg>
          <span>Dashboard</span>
        </div>
      ),
      href: "/#/dashboard",
    },
    {
      title: capitalize("Groups"),
    },
  ];

  return (
    <>
      <div className=" w-full overflow-y-scroll h-full">
        <div className="justify-between items-center white_card">
          <BreadCrumb
            breadList={breadList}
            header={"List of Groups"}
            info={"Manage your Groups here to make payments"}
            btn={true}
            btnTitle="Add Group"
            btnSvg={flash}
            onClick={handleAddGroup}
          />
        </div>
        <div className="">
          <div className="flex flex-col w-full border  border-[rgba(31,45,61,0.125)] mt-10">
            <div className="flex flex-col h-auto w-full justify-center items-center ">
              <div className="w-full h-full mt-0 lg:mt-[2.44rem]">
                <Form
                  form={form}
                  layout="vertical"
                  onValuesChange={(data) => {
                    dispatch(setActiveObj({ ...activeObj, ...data }));
                  }}
                >
                  <div className="hidden lg:flex items-center justify-center w-full lg:px-[10rem] px-3 ">
                    <Steps
                      className="items-center w-full"
                      current={current}
                      labelPlacement="horizontal"
                      items={items}
                    />
                  </div>
                  <div className="mt-[2.12rem]">{steps[current]?.content}</div>
                </Form>
              </div>
            </div>
          </div>
        </div>
      </div>

      <AddGroupModal
        handleFetchData={handleFetch}
        open={open}
        handleCancel={handleCancel}
        prodd={prodd1}
      />
    </>
  );
}
